import { styled, ListItemIcon as MuiListItemIcon } from '@mui/material';
export var StyledListItemIcon = styled(MuiListItemIcon)({});
//# sourceMappingURL=styled.js.map